import Trie from './Trie';

export default Trie;
